var _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBarScreen = function SvgBarScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1.491,
    height: 9.514,
    fill: "currentColor",
    rx: 0.746,
    transform: "matrix(.76712 .6415 -.37027 .92892 12.492 11.205)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.491,
    height: 4.443,
    fill: "currentColor",
    rx: 0.746,
    transform: "matrix(.76712 .6415 -.37027 .92892 22.856 15.916)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.491,
    height: 4.443,
    fill: "currentColor",
    rx: 0.746,
    transform: "matrix(.76712 .6415 -.37027 .92892 9.645 11)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1.491,
    height: 9.514,
    fill: "currentColor",
    rx: 0.746,
    transform: "matrix(.76712 .6415 -.37027 .92892 21.651 11.205)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.491,
    height: 9.514,
    fill: "currentColor",
    rx: 0.746,
    transform: "matrix(.76712 .6415 -.37027 .92892 18.569 11.205)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1.491,
    height: 9.514,
    fill: "currentColor",
    rx: 0.746,
    transform: "matrix(.76712 .6415 -.37027 .92892 15.486 11.205)"
  })));
};
export { SvgBarScreen as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='1.4914' height='9.51424' rx='0.7457' transform='matrix(0.767118 0.641506 -0.370272 0.928923 12.4921 11.2053)' fill='%234A6067'/%3e %3crect width='1.4914' height='4.44327' rx='0.7457' transform='matrix(0.767118 0.641506 -0.370272 0.928923 22.856 15.9158)' fill='%234A6067'/%3e %3crect width='1.4914' height='4.44327' rx='0.7457' transform='matrix(0.767118 0.641506 -0.370272 0.928923 9.64526 11)' fill='%234A6067'/%3e %3crect width='1.4914' height='9.51424' rx='0.7457' transform='matrix(0.767118 0.641506 -0.370272 0.928923 21.6511 11.2053)' fill='%234A6067'/%3e %3crect width='1.4914' height='9.51424' rx='0.7457' transform='matrix(0.767118 0.641506 -0.370272 0.928923 18.5686 11.2053)' fill='%234A6067'/%3e %3crect width='1.4914' height='9.51424' rx='0.7457' transform='matrix(0.767118 0.641506 -0.370272 0.928923 15.4861 11.2053)' fill='%234A6067'/%3e %3c/svg%3e";